<template>
  <div class="companies">
    <h1 v-bg-typography="'h1'">Users</h1>
    <div class="search">
      <div>
        <bg-field
          class="search-input"
          label="Search"
          v-model="searchString"
          name="search"
        >
          <bg-input
            name="search"
            placeholder="Type in a users name"
            v-model="searchString"
          />
        </bg-field>
      </div>

      <bg-button
        variant="primary"
        text="Add user"
        @click="goTo('/admin/users/new')"
        style="margin-bottom: 30px"
      />
    </div>

    <List
      ref="list"
      :headers="list.headers"
      :values="list.values"
      :actions="list.actions"
      :data="filteredItems"
      :fractions="list.fractions"
      :genderIcons="list.genderIcons"
      @change="getChanges"
      style="margin-bottom: 100px; max-width: 900px"
      v-if="!$store.state.users.loading"
      :pagination="true"
    />

    <bg-loader :dark="true" v-if="$store.state.users.loading"></bg-loader>
    <bg-modal
      v-if="isModalOpen"
      body="Are you sure you want to remove this user?"
      @close="isModalOpen = false"
    >
      <bg-button
        variant="secondary"
        text="Cancel"
        @click="isModalOpen = false"
      />
      <bg-button
        variant="destructive"
        class="action"
        text="Delete"
        @click="deleteUser"
      />
    </bg-modal>
  </div>
</template>

<style scoped>
.search {
  display: flex;
  align-items: flex-end;
  gap: 20px;
}
</style>

<script>
import BgList from "@/components/bg-list";
import BgTypography from "@/directives/bg-typography";
import BgModal from "@/components/bg-modal";
import BgButton from "@/components/bg-button";
import BgLoader from "@/components/bg-loader";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";

import List from "@/components/list";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "Users",
  components: {
    BgModal,
    BgList,
    BgButton,
    BgLoader,
    List,
    BgField,
    BgInput,
  },
  directives: {
    BgTypography,
  },

  watch: {
    searchString: function(val) {
      const child = this.$refs.list;
      child.paginationReset();
    },
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
    filteredItems: function() {
      let items = this.$store.state.users.users;
      let input = this.searchString.toLowerCase();

      function byFirstName(user) {
        let score = 0;
        if (user.profile && user.profile.first_name) {
          let firstName = user.profile.first_name.toLowerCase();
          if (firstName.includes(String(input))) {
            score++;
          }
        }
        if (user.profile && user.profile.last_name) {
          let lastName = user.profile.last_name.toLowerCase();
          if (lastName.includes(String(input))) {
            score++;
          }
        }
        if (user.email) {
          let email = user.email.toLowerCase();
          if (email.includes(String(input))) {
            score++;
          }
        }
        if (user.company && user.company.name) {
          let companyName = user.company.name.toLowerCase();
          if (companyName.includes(String(input))) {
            score++;
          }
        }

        if (score > 0) {
          return true;
        } else {
          return false;
        }
      }

      if (this.searchString) {
        items = items.filter(byFirstName);
      }

      return items;
    },
  },
  methods: {
    async deleteUser() {
      this.isLoading = true;
      this.isModalOpen = false;
      const res = await API.user.deleteUser(this.deleteUserId);
      console.log(res);
      await this.$store.dispatch("fetchAllUsers");
      this.fetchUsers();
    },
    getChanges(val) {
      if (val.action === "Select") {
        this.$router.push(`/admin/users/${val.item.id}`);
      } else if (val.action === "Delete") {
        this.isModalOpen = true;
        this.deleteUserId = val.item.id;
      }
    },
    goTo(url) {
      this.$router.push(url);
    },
  },
  data() {
    return {
      deleteUserId: null,
      isLoading: false,
      isModalOpen: false,
      items: [],
      list: {
        headers: ["Name", "Last name", "Email", "Company"],
        values: [
          "profile.first_name",
          "profile.last_name",
          "email",
          "company.name",
        ],
        fractions: [1, 1, 2, 1],
        actions: ["Delete"],
        genderIcons: false,
      },
      searchString: "",
    };
  },
};
</script>
